const MapperTypes = {
    ISessionManagementMapper: Symbol.for('ISessionManagementMapper'),
    IUserManagementMapper: Symbol.for('IUserManagementMapper'),
    IUserGeneratedContentMapper: Symbol.for('IUserGeneratedContentMapper'),
    IContentDeliveryMapper: Symbol.for('IContentDeliveryMapper'),
    ILocationMapper: Symbol.for('ILocationMapper'),
    ICompanyDataMapper: Symbol.for('ICompanyDataMapper'),
    IAuth0Mapper: Symbol.for('IAuth0Mapper'),
};

export { MapperTypes };
